import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationDashboardComponent } from './pages/dashboard/dashboard.component';
import { OrganizationRoutingModule } from './organization-routing.module';
import { ProfileComponent } from './pages/profile/profile.component';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { OrganizationPractitionerComponent } from './pages/practioner/practioner.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ProcedureComponent } from './pages/procedure/procedure.component';
import { ScheduleSelectComponent } from './pages/schedule/select/schedule-select.component';
import { CalendarComponent } from './pages/schedule/calendar/calendar.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { MatSelectModule } from '@angular/material/select';
import { SchedulerComponent } from './pages/scheduler/scheduler.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { LocationComponent } from './components/location/locationComponent';
import { OpeningHoursComponent } from './components/opening-hours/opening-hours.component';
import { ProcedureRegistrationComponent } from './pages/procedure/registration/procedure-registration.component';
import { MatDialogModule } from '@angular/material/dialog';
import { OrganizationPractitionerDetailsComponent } from './pages/practioner/details/practitioner-details.component';
import { OrganizationPractitionerLinkComponent } from './pages/practioner/bond/practioner-registration.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProcedureDetailsComponent } from './pages/procedure/registration/details/procedure-details.component';
import { OrganizationRegistrationComponent } from './components/organization-registration/organization-registration.component';
import { PaymentDetailsComponent } from './pages/payment/payment-details/payment-details.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HealthInsuranceComponent } from './pages/health-insurance/health-insurance.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { OrganizationUsersComponent } from './pages/users/users.component';
import { OrganizationUserDetailsComponent } from './pages/users/details/users-details.component';
import { OrganizationUserRegistrationComponent } from './pages/users/registration/users-registration.component';
import { MatRadioModule } from '@angular/material/radio';
import { OrganizationScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { OrganizationScheduleDetailsComponent } from './pages/schedule/status/details/schedule-details.component';
import { CalendarDayOptionsComponent } from './components/calendar-day-options/calendar-day-options.component';
import { ScheduleOrganizationEditStatusComponent } from './pages/schedule/status/edit-status/schedule-edit-status.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AddProceduresComponent } from './pages/practioner/add-procedures/select-procedure.component';
import { CreatePractitionerComponent } from './components/create-practitioner/create-practitioner.component';
import { PractitionerRegistrationComponent } from './components/create-practitioner/tabs/practitioner-registration/practitioner-registration.component';
import { PractitionerQualificationFormComponent } from './components/create-practitioner/tabs/qualification-form/qualification-form.component';
import { PractitionerPractitionerroleFormComponent } from './components/create-practitioner/tabs/practitionerrole/practitionerrole-form.component';
import { NonWorkingDaysComponent } from './pages/practioner/details/non-working-days/non-working-days.component';
import { MatNativeDateModule } from '@angular/material/core';
import { BlockedDayDialogComponent } from './pages/practioner/details/non-working-days/blocked-days-dialog/blocked-day-dialog.component';
import { OrganizationBankAccountComponent } from './components/organization-bank-account/organization-bank-account.component';
import { OrganizationPatientsComponent } from './pages/patients/patients.component';
import { OrganizationPatientEditComponent } from './pages/patients/patient-edit.component';

@NgModule({
  declarations: [
    OrganizationDashboardComponent,
    ProfileComponent,
    PaymentComponent,
    ProcedureComponent,
    ScheduleSelectComponent,
    CalendarComponent,
    ScheduleComponent,
    SchedulerComponent,
    LocationComponent,
    OpeningHoursComponent,
    ProcedureRegistrationComponent,
    ProcedureDetailsComponent,
    OrganizationPractitionerComponent,
    PaymentDetailsComponent,
    OrganizationPractitionerDetailsComponent,
    OrganizationPractitionerLinkComponent,
    OrganizationRegistrationComponent,
    HealthInsuranceComponent,
    OrganizationUsersComponent,
    OrganizationUserDetailsComponent,
    OrganizationUserRegistrationComponent,
    OrganizationScheduleStatusComponent,
    OrganizationScheduleDetailsComponent,
    CalendarDayOptionsComponent,
    ScheduleOrganizationEditStatusComponent,
    AddProceduresComponent,
    CreatePractitionerComponent,
    PractitionerRegistrationComponent,
    PractitionerQualificationFormComponent,
    PractitionerPractitionerroleFormComponent,
    NonWorkingDaysComponent,
    BlockedDayDialogComponent,
    OrganizationBankAccountComponent,
    OrganizationPatientsComponent,
    OrganizationPatientEditComponent,

    //SchedulerComponent
    //shared
    //BarChartComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OrganizationRoutingModule,
    SharedModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatCardModule,
    MatTabsModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatNativeDateModule,
  ],
  exports: [
    LocationComponent,
    OpeningHoursComponent,
    ProcedureRegistrationComponent,
    ProcedureDetailsComponent,
    OrganizationPractitionerDetailsComponent,
    OrganizationPractitionerLinkComponent,
    ProcedureDetailsComponent,
    OrganizationRegistrationComponent,
  ],
})
export class OrganizationModule {}
